<template lang="pug">
    include ./../../media/pug/mixins.pug
    +b.modal(
        v-on:click.self="isDisabledClose ? false : $store.dispatch('closeModal')"
    )
        +e.container(v-bind:class="containerClass")
            +e.head
                +e.H2.title._is_nowrap(
                    v-if="getModalBodyComponent == 'ModalDocInfo'"
                    v-html="documentTitle"
                )
                +e.H2.title(v-else) {{ getModalTitle }}
                +e.BUTTON.close-btn.btn(
                    v-if="!isDisabledClose"
                    v-on:click="$store.dispatch('closeModal')"
                )
                    +e.V-ICON.modal-close-svg(name="close")
            +e.body
                RslCardItem(
                    v-if="getModalBodyComponent == 'RslCardItem'"
                    v-bind='cardItem'
                )
                dynamic-component(
                    v-else
                    v-bind:path="`modal/modalContent/${getModalBodyComponent}`"
                )

</template>

<script>
import { mapGetters } from 'vuex';
import RslCardItem from '@RSL/RslCardItem/RslCardItem';
import DynamicComponent from '@/components/DynamicComponent';

export default {
    components: {
        DynamicComponent,
        RslCardItem
    },
    computed: {
        ...mapGetters([
            'getModalTitle',
            'getModalBodyComponent',
            'isMobile',
            'isTablet',
            'getDocInfo',
            'isSessionStatus'
        ]),
        isDisabledClose() {
            return this.getModalBodyComponent === 'ModalSession' && this.isSessionStatus === 'fatal';
        },
        documentTitle() {
            return `${this.getDocInfo.authorInfo} ${this.getDocInfo.cardTitle.split(' : ')[0]}`;
        },
        containerClass() {
            return {
                'modal__container-middle': ['ModalError', 'ModalWelcome', 'ModalSession', 'ModalRemoveMark']
                    .includes(this.getModalBodyComponent),
                'modal__container-small': this.getModalBodyComponent === 'ModalTestRoom'
            };
        },
        cardItem() {
            return {
                item: this.getDocInfo,
                t: {
                    goToAbstract: 'Перейти к автореферату',
                    elOrder: 'Электронный заказ',
                    viewRecord: 'Описание',
                    docUnavailable: 'Недоступно для просмотра',
                    quotesFromText: 'Цитаты из текста',
                    seeRelDocument: 'Посмотреть связанные документы',
                    periodical: 'Периодика',
                    upLink: 'Входит в',
                    pageNumber: 'Номер страницы',
                    content: 'Содержание',
                    systemNumber: 'Системный номер',
                    storageLocation: 'Хранение',
                    consistOf: 'Состоит из',
                    moreInfo: 'Дополнительная информация'
                },
                options: {
                    cardLink: `http://search.rsl.ru/ru/record/${this.$route.params.id}`,
                    isLinkViewMode: true,
                    navList: {
                        cardLink: true
                    }
                },
                icons: {
                    more: '/sprite.svg#list',
                    lock: '/sprite.svg#lock',
                    unlock: '/sprite.svg#unlock'
                }
            };
        }
    },
    created() {
        document.body.classList.add('body-fixed');
    },
    destroyed() {
        document.body.classList.remove('body-fixed');
    }
};
</script>

<style lang="sass" src="@/media/sass/components/modal/modal.sass"></style>
